import React, { useEffect, useState } from "react";
import { backendUrl } from "../backendUrl";

interface PropertyWithStatus {
  id: number;
  name: string;
  description: string | null;
  icon_path: string | null;
  column_name: string | null;
  is_active: boolean; // true = "Ja", false = "Nein"
}

interface DynamicIconsProps {
  product: {
    supllier: string;
    system1: string;
  };
}

// Funkcja normalizacji nazw systemów
function normalizeSystemName(name: string): string {
  if (!name) return '';
  return name
    .toLowerCase()
    .replace(/\+/g, 'plus')
    .replace(/\./g, '')
    .replace(/\s+/g, '')
    .replace(/-/g, '')
    .replace(/_/g, '');
}

const DynamicIcons: React.FC<DynamicIconsProps> = ({ product }) => {
  const [properties, setProperties] = useState<PropertyWithStatus[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Użyj normalizowanej nazwy systemu do wyszukiwania
        const normalizedSystem1 = normalizeSystemName(product.system1);
        
        // Najpierw spróbuj z oryginalną nazwą
        let response = await fetch(
          `${backendUrl}/api/v1/configurator/system-options/properties/${product.supllier}/${product.system1}`
        );
        
        if (!response.ok) {
          // Jeśli nie znaleziono, spróbuj z normalizowaną nazwą
          response = await fetch(
            `${backendUrl}/api/v1/configurator/system-options/properties/${product.supllier}/${normalizedSystem1}`
          );
        }
        
        const data = await response.json();
        
        // Upewnij się że data jest tablicą
        if (Array.isArray(data)) {
          setProperties(data);
        } else {
          console.error("Expected array but got:", data);
          setProperties([]);
        }
      } catch (error) {
        console.error("Error fetching system properties:", error);
        setProperties([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [product.supllier, product.system1]);

  if (loading) return null;

  return (
    <>
      {properties.map((property) => {
        const iconPath = property.icon_path || "";
        
        return (
          <img
            key={property.id}
            style={{
              width: "28px",
              height: "28px",
              marginRight: "8px",
              filter: property.is_active ? "none" : "grayscale(100%) opacity(0.4)",
              transition: "filter 0.3s ease"
            }}
            src={`${backendUrl}${iconPath}`}
            alt={property.name}
            title={`${property.name}${property.description ? ': ' + property.description : ''}`}
            loading="lazy"
            decoding="async"
            crossOrigin="anonymous"
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
          />
        );
      })}
    </>
  );
};

export default DynamicIcons;
